var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-badge',{staticClass:"p-1 font-weight-normal",attrs:{"variant":"green"}},[_vm._v(" "+_vm._s(_vm.$t('general.sporttype.' + _vm.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }